import { JournalId, GroupConsultationId } from 'types';

export const GROUP_CONSULTATIONS = (journalId: JournalId) =>
    `/api/v1/journals/${journalId}/group-consultations`;
export const GROUP_CONSULTATION = (journalId: JournalId, consultationId: GroupConsultationId) =>
    `/api/v1/journals/${journalId}/group-consultations/${consultationId}`;
